import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/data/types'

export default class DataRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set loading(value: boolean) {
    this.store.commit(new types.Loading(value))
  }

  get loading(): boolean {
    return this.store.state.data.loading
  }

  set saving(value: boolean | null) {
    this.store.commit(new types.Saving(value))
  }

  get saving(): boolean | null {
    return this.store.state.data.saving
  }

  set removing(value: boolean | null) {
    this.store.commit(new types.Removing(value))
  }

  get removing(): boolean | null {
    return this.store.state.data.removing
  }

  set finished(value: boolean | string | null) {
    this.store.commit(new types.Finished(value))
  }

  get finished(): boolean | string | null {
    return this.store.state.data.finished
  }

  set errors(value: any) {
    this.store.commit(new types.Errors(value))
  }

  get errors(): any {
    return this.store.state.data.errors
  }

  set dialog(value: boolean | null) {
    this.store.commit(new types.Dialog(value))
  }

  get dialog(): boolean | null {
    return this.store.state.data.dialog
  }

  set clone(value: any) {
    this.store.commit(new types.Clone(value))
  }

  get clone(): any {
    return this.store.state.data.clone
  }

  set saved(value: boolean) {
    this.store.commit(new types.Saved(value))
  }

  get saved(): boolean {
    return this.store.state.data.saved
  }

  set to(value: any) {
    this.store.commit(new types.To(value))
  }

  get to(): any {
    return this.store.state.data.to
  }

  set none(value: boolean | null) {
    this.store.commit(new types.None(value))
  }

  get none(): boolean | null {
    return this.store.state.data.none
  }

  set message(value: string) {
    this.store.commit(new types.Message(value))
  }

  get message(): string {
    return this.store.state.data.message
  }

  set title(value: string) {
    this.store.commit(new types.Title(value))
  }

  get title(): string {
    return this.store.state.data.title
  }

  set button(value: string) {
    this.store.commit(new types.Button(value))
  }

  get button(): string {
    return this.store.state.data.button
  }

  set controller(value: { [id: string]: AbortController | null } | null) {
    this.store.commit(new types.Controller({ ...value }))
  }

  get controller(): { [id: string]: AbortController | null } | null {
    return this.store.state.data.controller
  }

  get scrollHeight(): number | null {
    return this.store.state.data.scrollHeight
  }

  set scrollHeight(value: number | null) {
    this.store.commit(new types.ScrollHeight(value))
  }

  set offsetHeight(value: number | null) {
    this.store.commit(new types.OffsetHeight(value))
  }

  get offsetHeight(): number | null {
    return this.store.state.data.offsetHeight
  }

  set scrollTop(value: number | null) {
    this.store.commit(new types.ScrollTop(value))
  }

  get scrollTop(): number | null {
    return this.store.state.data.scrollTop
  }

  set checkin(value: boolean) {
    this.store.commit(new types.Checkin(value))
  }

  get checkin(): boolean {
    return this.store.state.data.checkin
  }

  set withdraw(value: boolean) {
    this.store.commit(new types.Withdraw(value))
  }

  get withdraw(): boolean {
    return this.store.state.data.withdraw
  }
}
